/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryFileType } from '../../models/binary-file-type';
import { KeyType } from '../../models/key-type';

export interface GetConsigneeDiscrepancyImageAttachment$Jpeg$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
  attachmentKey: KeyType;
}

export function getConsigneeDiscrepancyImageAttachment$Jpeg(http: HttpClient, rootUrl: string, params: GetConsigneeDiscrepancyImageAttachment$Jpeg$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeDiscrepancyImageAttachment$Jpeg.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('attachmentKey', params.attachmentKey, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/jpeg', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BinaryFileType>;
    })
  );
}

getConsigneeDiscrepancyImageAttachment$Jpeg.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/discrepancy-images/{attachmentKey}';
